export default {
  data() {
    return {

      //Voice
      showDialog_Voice: false,
      isRecording: false,
      isLoading_Voice: false,
      error_Voice: '',

      // متغیرهای ضبط
      mediaRecorder: null,
      audioChunks: [],
      stream: null,

      // تایمر
      timerInterval: null,
      recordingSeconds: 0,

      // لیست ویس‌ها
      voiceList: [],

      // پخش‌کننده
      currentAudio: null,
      //Voice
      currentMission800TopListTableHeader: [
        {
          text: '',
          value: 'icon',
          align: 'center',
          width: '30px',
          sortable: false,
        },
        { text: 'شهر', value: 'city', sortable: false, align: 'center' },
        { text: 'آدرس', value: 'address', sortable: false, align: 'center' },
        {
          text: 'زمان دریافت',
          sortable: false,
          value: 'reciveTime',
          align: 'center',
        },
        { text: 'تلفن', value: 'phone', sortable: false, align: 'center' },
        {
          text: 'کد پیشنهادی',
          sortable: false,
          value: 'code',
          align: 'center',
        },
        {
          text: 'تشخیص',
          sortable: false,
          value: 'cc',
          align: 'center',
          width: '200px',
        },
        { text: 'ناحیه', value: 'zone', sortable: false, align: 'center' },
        { text: 'کاربر', value: 'user', sortable: false, align: 'center' },
      ],
      currentMission800TopList: [],
      isTerminehModalOpen: false,
      selectedZone: [],
      currentMissionSearchText: '',
      show1024Flag: true,
      listOf1024Missions: [],
      //send
      sendTOPhoneModal: false,
      missionId: null,
      missionSendInfo: {},
      missionSendInfoNew: {},
      missionRankText: '',
      missionRankIconClass: '',
      missionRankIconColor: '',
      readyPhonesList: [],
      topNearestCodeList: [],
      readyPhonesByStationList: [],
      selectedMissionLakeCode: null,
      selectedPhoneCode: null,
      topNearestLoaderFlag: false,
      topNearestFenceLoaderFlag: false,
      missionIsStarred: false,
      sendModalType: '',
      mapMovingIconInterval: null,
      dispatch800MapClickHandler: null,
      topListChangeInterval: null,
      //delete
      deletemodal: false,
      selectedReason: '',
      removeReason: '',
      //other organ
      otherOrganModal: false,
      selectedOtherOrgan: null,
      //fence
      fence800Coords: [],
      fence800CoordsTemp: [],
      mapSearchText: '',
      selected800Position: null,
      patiantPosition: null,
      fenceFlag: true,
      //attach
      attachmentListSearch: '',
      attachmentModal: false,
      attachmentModalTitle: '',
      attachmentCurrentMissionListHeader: [
        { text: '', value: 'check', align: 'right' },
        { text: 'کد', value: 'code', align: 'right' },
        {
          text: 'شکایت اصلی',
          value: 'chiefComplaintTitle',
          align: 'right',
          width: '200',
        },
        { text: 'آدرس', value: 'address', align: 'right' },
      ],
      selectedRow: -1,
      destinationMissionId: null,
      filteredBottomList: [],
      //bottom list
      bottomList: [],
      //rtl
      /* bottomListTableHeader: [
                 { text: "", value: "icon", align: "right", sortable: false, width: "90px" },
                 { text: "کد آمبولانس", value: "ambulanceCode", align: "right", width: "120px" },
                 { text: "کد شبرنگ", value: "shabrangCode", align: "right", width: "100px" },
                 { text: "آدرس", value: "address", align: "right", width: "400px" },
                 { text: "شکایت اصلی", value: "cc", align: "right", width: "150px" },
                 { text: "وضعیت قبلی ماموریت", value: "beforStatus", align: "right", width: "170px" },
                 { text: "وضعیت ماموریت", value: "status", align: "right", width: "150px" },
                 { text: "وضعیت آمبولانس", value: "ambulanceStatus", align: "right", width: "140px" },
                 { text: "بیمارستان", value: "hospital", align: "right", width: "100px" },
                 { text: "تلفن اصلی / پیگیری", value: "phoneNumber", align: "right", width: "150px" },
                 { text: "کاربر 115 ", value: "user", align: "right", width: "150px" },
                 { text: "ناحیه", value: "zone", align: "right", width: "90px" },
             ],*/
      //ltr
      bottomListTableHeader: [
        {
          text: 'ناحیه',
          sortable: false,
          value: 'zone',
          align: 'right',
          width: '90px',
        },
        {
          text: 'کاربر 115 ',
          sortable: false,
          value: 'user',
          align: 'right',
          width: '150px',
        },

        {
          text: 'توضیح شکایت',
          sortable: false,
          value: 'ccNote',
          align: 'right',
          width: '220px',
        },
        {
          text: 'شکایت اصلی',
          sortable: false,
          value: 'chiefComplaintText',
          align: 'right',
          width: '150px',
        },
        {
          text: 'بیمارستان',
          sortable: false,
          value: 'hospital',
          align: 'right',
          width: '100px',
        },
        {
          text: 'وضعیت آمبولانس',
          sortable: false,
          value: 'ambulanceStatus',
          align: 'right',
          width: '140px',
        },
        {
          text: 'وضعیت ماموریت',
          sortable: false,
          value: 'status',
          align: 'right',
          width: '150px',
        },
        {
          text: 'وضعیت قبلی کد',
          sortable: false,
          value: 'phonePreviousState',
          align: 'right',
          width: '180px',
        },
        {
          text: 'وضعیت کد',
          sortable: false,
          value: 'phoneStatus',
          align: 'right',
          width: '140px',
        },
        {
          text: 'تشخیص',
          value: 'cc',
          sortable: false,
          align: 'right',
          width: '270px',
        },
        {
          text: 'تلفن اصلی / پیگیری',
          sortable: false,
          value: 'phoneNumber',
          align: 'right',
          width: '160px',
        },
        {
          text: 'آدرس',
          value: 'address',
          sortable: false,
          align: 'right',
          width: '400px',
        },
        {
          text: 'کد شبرنگ',
          value: 'shabrangCode',
          sortable: false,
          align: 'right',
          width: '100px',
        },
        {
          text: 'کد آمبولانس',
          value: 'ambulanceCode',
          sortable: false,
          align: 'right',
          width: '120px',
        },
        {
          text: 'وضعیت',
          value: 'icon',
          align: 'right',
          sortable: false,
          width: '90px',
        },
      ],
      bottomListManualRefreshLoaderFlag: false,
      isTopListLoading: false,
      //edit
      editModal: false,
      missionPhoneId: null,
      missionPhoneCode: '',
      phoneId: null,
      phoneCode: null,
      //right click
      colorTags: [
        { title: 'red', id: 1, color: '#1EAA6E' },
        { title: 'blue', id: 2, color: '#792554' },
        { title: 'orange', id: 3, color: '#D7712D' },
        { title: 'green', id: 4, color: '#E15858' },
      ],
      showMenu: false,
      x: 0,
      y: 0,
      rightClickItems: [
        { title: 'اعزام کد مجدد', icon: 'mdi-send mdi-18px' },
        { title: 'درخواست موقعیت', icon: 'mdi-map-marker mdi-18px' },
        { title: '10-24 موقت', icon: 'mdi-car-clock mdi-18px' },
        { title: 'تماس داخلی', icon: 'mdi-phone-log mdi-flip-h mdi-18px' },
        { title: 'تماس خارجی', icon: 'mdi-phone-forward mdi-flip-h mdi-18px' },
        { title: 'تماس با کد', icon: 'mdi-phone mdi-flip-h mdi-18px' },
        { title: 'تماس با مددجو', icon: 'mdi-card-account-phone mdi-18px' },
      ],
      rightClickData: null,
      closeOnContentClick: false,
      codePhoneNumbers: [],
      patientPhoneNumbers: [],
      iternalPhoneNumber: '',
      externalPhoneNumber: '',
      dbClickMouseInfo: null,
      disabelConfirm: false,
      topListSoundStop: true,
      bottomListSoundIsPlay: false,
      bottomListItemsModal: false,
    };
  },
  methods: {
    stopTopListSound() {
      this.topListSoundStop = true;
    },
    showSendToPhoneModal: function (value, data) {
      this.missionSendInfoNew = {};
      this.selectedPhoneCode = null;
      this.topNearestCodeList = [];
      this.readyPhonesByStationList = [];
      this.missionSendInfo = {};

      this.stopTopListSound();
      this.sendModalType = 'main';
      this.missionId = data.item.id;
      this.getMissionForDispatchSendMissionFunction(data.item.id);
      this.getAllStationCoverageZonesForAllStations();
      this.getAllPhoneOnlineLocationFunction();
      this.mapMovingIconInterval = setInterval(() => {
        this.getAllPhoneOnlineLocationFunction();
      }, 4000);
      this.sendTOPhoneModal = true;
    },
    openTerminehModal: function () {
      this.isTerminehModalOpen = true;
    },
    closeTerminehModal: function () {
      this.isTerminehModalOpen = false;
    },
    addMissionLakeCode: function () {
      if (this.selectedMissionLakeCode) {
        let flag = false;
        if (this.missionSendInfo.missionLackOfCodes.length > 0) {
          for (let i = 0; i < this.missionSendInfo.missionLackOfCodes.length; i++) {
            if (
              this.missionSendInfo.missionLackOfCodes[i].station.id == this.selectedMissionLakeCode
            ) {
              flag = true;
            }
          }
        }
        if (flag == false) {
          this.addMissionLackOfCodeFunction(this.missionId, this.selectedMissionLakeCode);
        } else {
          this.snackText = 'منطقه قبلا اضافه شده است';
          this.$refs.snackRef.snackModel = true;
          this.snackColor = '#FF5252';
          this.snakIcon = 'mdi-information';
        }
      } else {
        this.snackText = 'منطقه را وارد نمایید';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
      }
    },
    selectCodeFromAdvice: function (data) {
      this.selectedPhoneCode = data.id;
    },
    showConfirmDialogFunction: function () {
      this.$refs.confirm.title = 'ارسال موقعیت انتخابی';
      this.$refs.confirm.text = 'آیا موقعیت انتخابی ارسال شود؟';
      this.$refs.confirm.showConfirmDialog = true;
      requestAnimationFrame(() => {
        if (this.$refs.yes) {
          this.$refs.yes.$el.focus();
        }
      });
    },
    showConfirmDialogFor10_24: function () {
      this.sendModalType = '10-24-confirmation';
      this.$refs.confirm.title = '10-24 موقت';
      this.$refs.confirm.text = 'آیا از فعال سازی 10-24 اطمینان دارید؟';
      this.$refs.confirm.showConfirmDialog = true;
      requestAnimationFrame(() => {
        if (this.$refs.yes) {
          this.$refs.yes.$el.focus();
        }
      });
    },
    resetConfirmDialog: function () {
      this.$refs.confirm.title = '';
      this.$refs.confirm.text = '';
      this.$refs.confirm.showConfirmDialog = false;
    },
    confirmDialogConfirmFunction: function () {
      this.disabelConfirm = true;
      if (this.sendModalType === 'main') {
        this.senMissionToPhoneFunction();
      } else if (this.sendModalType === '10-24-confirmation') {
        this.rightClickAction('10-24 موقت', null);
      }
      this.resetConfirmDialog();
    },
    confirmDialogCancelFunction: function () {
      this.disabelConfirm = true;
      if (this.sendModalType == 'main') {
        this.senMissionToPhoneFunction();
      } else if (this.sendModalType === 'repeat') {
        this.selected800Position = null;
        // this.sendMissionToOtherCodeFunction();
        this.resetConfirmDialog();
      } else {
        this.resetConfirmDialog();
      }
    },
    sendMissionToPhoneCheckType: function () {
      if (!this.selectedPhoneCode) {
        this.snackText = 'کد نمی تواند خالی باشد.';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        return;
      }
      if (this.selected800Position) {
        this.showConfirmDialogFunction();
      } else {
        this.senMissionToPhoneFunction();
      }
    },
    sendToOtherCodeConfirmation: function () {
      this.$refs.confirmSendingOtherCode.title = 'آیا کد  انتخابی ,کمکی(51-10) است ؟';
      this.$refs.confirmSendingOtherCode.text = '';
      this.$refs.confirmSendingOtherCode.showConfirmDialog = true;
      requestAnimationFrame(() => {
        if (this.$refs.yes) {
          this.$refs.yes.$el.focus();
        }
      });
    },
    acceptSendingToOtherCodeConfirmation: function () {
      this.sendMissionToOtherCodeFunction(true);
      this.ignoreSendingOtherCodeConfirmation();
    },
    cancelSendingOtherCodeConfirmation: function () {
      this.sendMissionToOtherCodeFunction(false);
      this.ignoreSendingOtherCodeConfirmation();
    },
    ignoreSendingOtherCodeConfirmation: function () {
      this.$refs.confirmSendingOtherCode.title = null;
      this.$refs.confirmSendingOtherCode.text = null;
      this.$refs.confirmSendingOtherCode.showConfirmDialog = false;
    },
    toggle1024: function (value) {
      this.show1024Flag = value;
    },
    //other organ
    showOtherOrganModal: function () {
      this.allMissionOtherOrganizationRequests = [];
      this.allMissionOtherOrganizationInforms = [];
      this.getAllMissionOtherOrganizationRequestsFor800TopListFunction(this.missionId);
      this.getListOfOtherOrganizationsForOther();
      this.getAllMissionOtherOrganizationInformsFor800TopListFunction(this.missionId);
      this.otherOrganModal = true;
    },
    closeOtherOrganModal: function () {
      this.selectedOtherOrgan = null;
      this.otherOrganModal = false;
    },
    addSeletctedOtherOrgan: function () {
      if (!this.selectedOtherOrgan) {
        this.snackText = 'لطفا سازمان همکار را انتخاب نمایید';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        return;
      }
      for (let i = 0; i < this.allMissionOtherOrganizationInforms.length; i++) {
        if (this.allMissionOtherOrganizationInforms[i].id == this.selectedOtherOrgan) {
          this.snackText = 'سازمان همکار قبلا اضافه شده است';
          this.$refs.snackRef.snackModel = true;
          this.snackColor = '#FF5252';
          this.snakIcon = 'mdi-information';
          return;
        }
      }
      let data = {
        missionId: Number(this.missionId),
        otherOrganizationId: Number(this.selectedOtherOrgan),
      };
      this.addMissionOtherOrganizationInformsFunction(data);
    },
    callToOtherOrgan: function (number) {
      if (number) {
        let data = {
          missionId: this.missionId,
          missionPhoneId: this.missionPhoneId,
          to: number,
        };
        this.callToOtherOrganizationFunction(data);
      }
    },
    //delete
    showDeleteModal: function () {
      this.getListOfCancelReasons();
      this.deletemodal = true;
    },
    cancelReasonChanged: function () {
      this.removeReason = this.selectedReason;
    },
    missionSuccesfulyRemove: function () {
      this.deletemodal = false;
      this.selectedReason = '';
      this.removeReason = '';
      this.mapSearchText = '';
      this.selectedPhoneCode = null;
      this.selected800Position = null;
      this.patiantPosition = null;
      clearInterval(this.mapMovingIconInterval);
      this.sendTOPhoneModal = false;
    },
    cancelRemoveMission: function () {
      this.deletemodal = false;
      this.selectedReason = '';
      this.removeReason = '';
    },
    //fence
    readyFencesFor800Map: function (data) {
      this.fence800Coords = [];
      for (let i = 0; i < data.length; i++) {
        let tempFence = {
          latlngs: [],
          color: data[i].fenceColor,
          moreInfo: [],
          id: data[i].id,
          title: data[i].title,
        };
        for (let j = 0; j < data[i].stationCoverageZoneFences.length; j++) {
          let info = [];
          info.push(data[i].stationCoverageZoneFences[j].latitude);
          info.push(data[i].stationCoverageZoneFences[j].longitude);
          tempFence.latlngs.push(info);
        }
        for (let j = 0; j < data[i].stationCoverageZoneSupportStations.length; j++) {
          let title = data[i].stationCoverageZoneSupportStations[j].station
            ? data[i].stationCoverageZoneSupportStations[j].station.title
            : '-';
          tempFence.moreInfo.push({
            title: title,
            id: data[i].stationCoverageZoneSupportStations[j].id,
          });
        }
        this.fence800Coords.push(tempFence);
      }
    },
    get800MapLatLng: function (latlng) {
      if (!latlng) return null;
      const lat = Number(latlng.lat);
      const lng = Number(latlng.lng);

      if (!Number.isFinite(lat) || !Number.isFinite(lng)) return null;

      return { lat, lng };
    },
    is800PointInFence: function (point, fence) {
      if (!point || !fence?.latlngs || fence.latlngs.length < 3) return false;

      let inside = false;
      const { lat, lng } = point;

      for (let i = 0, j = fence.latlngs.length - 1; i < fence.latlngs.length; j = i++) {
        const current = fence.latlngs[i];
        const previous = fence.latlngs[j];
        const currentLat = Number(current[0]);
        const currentLng = Number(current[1]);
        const previousLat = Number(previous[0]);
        const previousLng = Number(previous[1]);

        if (
          !Number.isFinite(currentLat) ||
          !Number.isFinite(currentLng) ||
          !Number.isFinite(previousLat) ||
          !Number.isFinite(previousLng)
        ) {
          continue;
        }

        const intersects =
          currentLng > lng !== previousLng > lng &&
          lat <
          ((previousLat - currentLat) * (lng - currentLng)) / (previousLng - currentLng) +
          currentLat;

        if (intersects) inside = !inside;
      }

      return inside;
    },
    get800FenceByLatLng: function (latlng) {
      const point = this.get800MapLatLng(latlng);
      if (!point) return null;

      return this.fence800Coords.find((fence) => this.is800PointInFence(point, fence)) || null;
    },
    update800FencePhonesByLatLng: function (latlng) {
      const fence = this.get800FenceByLatLng(latlng);

      if (fence?.id) {
        this.getListOfReadyPhonesBy800UserFunction(fence.id);
      } else {
        this.readyPhonesByStationList = [];
      }
    },
    flyTo800PatientPosition: function () {
      const position = this.get800MapLatLng(this.patiantPosition);

      if (!position || !this.sendTOPhoneModal) return;

      this.$nextTick(() => {
        const map = this.$refs.modalmap?.mapObject;
        if (map) {
          map.flyTo([position.lat, position.lng], 16);
        }
      });
    },
    reset800DispatchMapState: function () {
      this.mapSearchText = '';
      this.searchCode = '';
      this.selectedPhoneCode = null;
      this.selected800Position = null;
      this.patiantPosition = null;
      this.topNearestCodeList = [];
      this.readyPhonesByStationList = [];
      this.topNearestLoaderFlag = false;
      this.topNearestFenceLoaderFlag = false;

      if (!this.fenceFlag && this.fence800CoordsTemp.length > 0) {
        this.fence800Coords = [...this.fence800CoordsTemp];
        this.fence800CoordsTemp = [];
        this.fenceFlag = true;
      }
    },
    bind800DispatchMapClick: function () {
      this.$nextTick(() => {
        const map = this.$refs.modalmap?.mapObject;
        if (!map) return;

        if (this.dispatch800MapClickHandler) {
          map.getContainer().removeEventListener('click', this.dispatch800MapClickHandler, true);
        }

        this.dispatch800MapClickHandler = (event) => {
          if (event.target?.closest?.('.leaflet-control')) return;

          const latlng = map.mouseEventToLatLng(event);
          this.add800SelectedMarker({ latlng });
        };
        map.getContainer().addEventListener('click', this.dispatch800MapClickHandler, true);
      });
    },
    unbind800DispatchMapClick: function () {
      const map = this.$refs.modalmap?.mapObject;

      if (map && this.dispatch800MapClickHandler) {
        map.getContainer().removeEventListener('click', this.dispatch800MapClickHandler, true);
      }

      this.dispatch800MapClickHandler = null;
    },
    on800DispatchMapReady: function () {
      this.mapInvalidate();
      this.bind800DispatchMapClick();
    },
    add800SelectedMarker: function (event) {
      if (this.sendModalType !== 'main') {
        return
      }
      const latlng = this.get800MapLatLng(event?.latlng);

      if (!latlng) return;

      this.selected800Position = latlng;
      if (latlng.lat) {
        this.getListOfTopNearestPhonesFor800Function(latlng.lat, latlng.lng);
      }
      this.update800FencePhonesByLatLng(latlng);
      // if (this.sendModalType !== 'main') {
      //   this.showConfirmDialogFunction();
      // }
    },
    fenceClick: function (event, data) {
      this.getListOfReadyPhonesBy800UserFunction(data.id);
      this.add800SelectedMarker(event);
    },
    toggle800FenceVisibility: function () {
      if (this.fenceFlag == true) {
        this.fenceFlag = false;
        this.fence800CoordsTemp = [];
        for (let i = 0; i < this.fence800Coords.length; i++) {
          this.fence800CoordsTemp.push(this.fence800Coords[i]);
        }
        this.fence800Coords = [];
      } else if (this.fenceFlag == false) {
        this.fenceFlag = true;
        this.fence800Coords = [];
        for (let i = 0; i < this.fence800CoordsTemp.length; i++) {
          this.fence800Coords.push(this.fence800CoordsTemp[i]);
        }
        this.fence800CoordsTemp = [];
      }
    },
    //map search
    searchForAddressOnMap: function () {
      this.getMapGeoCode(this.mapSearchText);
    },
    goToAddress: function (data) {
      this.$refs.modalmap.mapObject.flyTo([data.longitude, data.latitude], 16);
    },
    //stared
    missionSuccessfulyStared: function () {
      this.reset800DispatchMapState();
      clearInterval(this.mapMovingIconInterval);
      this.sendTOPhoneModal = false;
      this.refreshTopListManual()
    },
    closeSendToPhoneModal: function () {
      this.removeSelectedZone800Function()
      if (this.center) {
        this.$refs.modalmap.mapObject.flyTo(this.center, 13);
      }

      this.disabelConfirm = false;
      this.unbind800DispatchMapClick();
      this.reset800DispatchMapState();
      this.stopTopListSound();
      clearInterval(this.mapMovingIconInterval);
      this.sendTOPhoneModal = false;
    },
    //attach
    showCurrentMissionAttachmentModal: function () {
      this.attachmentListSearch = ''
      this.attachmentModalTitle = 'پیوست';
      this.getListOfAttachmentMissionFunction();
      this.attachmentModal = true;
    },
    attachmentTableClick: function (data) {
      let temp = this.allAttachment;
      this.allAttachment = [];
      for (let i = 0; i < temp.length; i++) {
        if (temp[i].missionId != data.missionId) {
          temp[i].check = false;
        } else {
          temp[i].check = true;
          this.destinationMissionId = data.missionId;
        }
      }
      this.allAttachment = temp;
    },
    cancelAttachment: function () {
      this.destinationMissionId = null;
      this.allAttachment.forEach((c) => (c.check = false));
      this.allAttachment = [];
      this.attachmentModal = false;
    },
    missionSuccessfulyAttach: function () {
      this.destinationMissionId = null;
      this.allAttachment.forEach((c) => (c.check = false));
      this.allAttachment = [];
      this.attachmentModal = false;
      this.mapSearchText = '';
      this.selectedPhoneCode = null;
      this.selected800Position = null;
      this.patiantPosition = null;
      clearInterval(this.mapMovingIconInterval);
      this.sendTOPhoneModal = false;
    },
    //edit
    showEditModal: function (value, data) {
      this.missionPhoneId = data.item.id;
      this.missionPhoneCode = data.item.ambulanceCode;
      this.missionId = data.item.missionId;
      this.phoneId = data.item.phoneId;
      this.phoneCode = data.item.ambulanceCode;
      this.editModal = true;
      /*this.getMissionForDispatchSendMissionFunction(data.item.id);
            this.getAllStationCoverageZonesForAllStations();*/
    },
    closeEditModal: function () {
      this.$root.$refs.Edit800Mission.clearSetIntrvals();
      this.editModal = false;
    },
    onTerminehSuccess: function () {
      this.closeEditModal();
    },
    resetSelectedRow() {
      this.selectedRow = -1;
    },
    onContextClick(e, data) {
      this.rightClickHandler(e, data);
      this.selectedRow = data?.item?.id;
    },
    //right click
    rightClickHandler(e, data) {
      e.preventDefault();
      this.missionPhoneId = data.item.id;
      this.missionId = data.item.missionId;
      this.phoneId = data.item.phoneId;
      this.rightClickData = data.item;
      this.codePhoneNumbers = data.item.codePhoneNumber;
      this.patientPhoneNumbers = data.item.patiantPhoneNumbers;
      this.showMenu = false;
      this.x = e.clientX;
      this.y = e.clientY;
      this.$nextTick(() => {
        this.showMenu = true;
      });
    },
    rightClickAction: function (type, to) {
      this.showMenu = false;
      if (type == 'اعزام کد مجدد') {
        this.showSendToPhoneModalByRightClick();
      } else if (type == 'درخواست موقعیت') {
        this.positionRequestFunction(this.phoneId);
        this.showMenu = false;
      } else if (type == 'تماس با کد') {
        if (to) {
          let data = {
            missionPhoneId: this.missionPhoneId,
            missionId: this.missionId,
            to: to,
          };
          this.callToCodeFunction(data);
          this.showMenu = false;
        } else {
          this.snackText = 'برای ماموریت کد وجود ندارد';
          this.$refs.snackRef.snackModel = true;
          this.snackColor = '#FF5252';
          this.snakIcon = 'mdi-information';
          return;
        }
      } else if (type == 'تماس با مددجو') {
        if (to) {
          let data = {
            missionPhoneId: this.missionPhoneId,
            missionId: this.missionId,
            to: to,
          };
          this.callToPatientFunction(data);
          this.showMenu = false;
        }
      } else if (type == 'تماس داخلی') {
        if (this.iternalPhoneNumber) {
          let data = {
            missionPhoneId: this.missionPhoneId,
            missionId: this.missionId,
            to: this.iternalPhoneNumber,
          };
          this.callToInternalFunction(data);
          this.iternalPhoneNumber = '';
          this.showMenu = false;
        } else {
          this.snackText = 'شماره تماس را وارد نمایید';
          this.$refs.snackRef.snackModel = true;
          this.snackColor = '#FF5252';
          this.snakIcon = 'mdi-information';
          return;
        }
      } else if (type === 'تماس خارجی') {
        if (this.externalPhoneNumber) {
          let data = {
            missionPhoneId: this.missionPhoneId,
            missionId: this.missionId,
            to: this.externalPhoneNumber,
          };
          this.callToCustomNumber(data);
          this.externalPhoneNumber = '';
          this.showMenu = false;
        } else {
          this.snackText = 'شماره تماس را وارد نمایید';
          this.$refs.snackRef.snackModel = true;
          this.snackColor = '#FF5252';
          this.snakIcon = 'mdi-information';
          return;
        }
      } else if (type === '10-24 موقت') {
        this.missionPhoneTemp1024Function(this.missionPhoneId);
        this.showMenu = false;
      }
    },
    showSendToPhoneModalByRightClick: function () {
      this.sendModalType = 'repeat';
      this.sendTOPhoneModal = true;
      this.getMissionForDispatchSendMissionFunction(this.missionId);
      this.getAllStationCoverageZonesForAllStations();
      this.getAllPhoneOnlineLocationFunction();
      this.mapMovingIconInterval = setInterval(() => {
        this.getAllPhoneOnlineLocationFunction();
      }, 4000);
    },
    setToopackForMission: function (toopack) {
      let id = '';
      if (this.missionPhoneId) {
        id = this.missionPhoneId.toString();
        id = id + this.missionId.toString();
      } else {
        id = this.missionId.toString();
      }
      localStorage.setItem(id, toopack.color);
      this.snackText = 'برچسب با موفقیت ثبت شد.';
      this.$refs.snackRef.snackModel = true;
      this.snackColor = '#4CAF50';
      this.snakIcon = 'mdi-check-circle';
      this.getListOfDispatchBottomListFunction();
      this.showMenu = false;
    },
    callToPatient: function (number, flag = true, dataObj) {
      if (number) {
        if (flag) {
          let data = {
            missionId: this.missionId,
            missionPhoneId: this.missionPhoneId,
            to: number,
          };
          this.callToPatientFunction(data);
        } else {
          this.callToPatientFunction(dataObj);
        }
      }
    },
    //refresh
    refreshBottomListManual: function () {
      this.bottomList = [];
      this.bottomListManualRefreshLoaderFlag = true;
      this.getListOfDispatchBottomListFunction();
    },
    refreshTopListManual: function () {
      this.getListOfMissionsForDispatchTopListFunction(true, false);
    },
    handleClickIconStatus: function (id, data) {
      if (data?.icon == 'mdi-circle mdi-18px') {
        localStorage.removeItem(id);
        this.getListOfDispatchBottomListFunction();
      }
      // if (data?.type == "voice") {
      //   this.showDialog_Voice = true
      // }
    },
    showBottomListItemsModal() {
      this.bottomListItemsModal = true;
    },

    //Voice
    async startRecording() {
      this.error_Voice = '';
      this.isLoading_Voice = true;

      try {
        this.stream = await navigator.mediaDevices.getUserMedia({ audio: true });

        this.mediaRecorder = new MediaRecorder(this.stream);
        this.audioChunks = [];

        this.mediaRecorder.ondataavailable = event => {
          if (event.data.size > 0) {
            this.audioChunks.push(event.data);
          }
        };

        this.mediaRecorder.onstop = this.saveRecording;

        this.mediaRecorder.start();
        this.isRecording = true;
        this.recordingSeconds = 0;

        this.timerInterval = setInterval(() => {
          this.recordingSeconds++;
        }, 1000);

      } catch (err) {
        console.error('خطا در دسترسی به میکروفون:', err);
        this.error_Voice = 'دسترسی به میکروفون ممکن نیست یا مرورگر پشتیبانی نمی‌کند. (نیاز به HTTPS)';
      } finally {
        this.isLoading_Voice = false;
      }
    },

    stopRecording() {
      if (this.mediaRecorder && this.isRecording) {
        this.mediaRecorder.stop();
        this.isRecording = false;

        // توقف ترک‌های میکروفون
        this.stream.getTracks().forEach(track => track.stop());

        // توقف تایمر
        clearInterval(this.timerInterval);
      }
    },

    saveRecording() {
      const audioBlob = new Blob(this.audioChunks, { type: 'audio/webm' });
      const audioUrl = URL.createObjectURL(audioBlob);

      const newVoice = {
        id: Date.now(),
        blob: audioBlob,
        url: audioUrl,
        duration: this.recordingSeconds,
        date: new Date().toLocaleTimeString('fa-IR')
      };

      this.voiceList.unshift(newVoice);
      this.saveVoicesToStorage();

      this.audioChunks = [];
      this.recordingSeconds = 0;
    },
    playVoice(voice) {
      const player = this.$refs.audioPlayer;

      if (this.currentAudio === voice.id) {
        if (player.paused) player.play();
        else player.pause();
        return;
      }

      this.currentAudio = voice.id;
      player.src = voice.url;
      player.play();
    },

    onAudioEnded() {
      this.currentAudio = null;
    },

    // 5. مدیریت LocalStorage
    saveVoicesToStorage() {
      try {
        // نکته: Blob مستقیماً در JSON ذخیره نمی‌شود، باید تبدیل به Base64 شود
        // برای سادگی، در این مثال فرض می‌کنیم اطلاعات ذخیره نمی‌شود یا صرفاً در حافظه است
        // localStorage.setItem('voiceMessages', JSON.stringify(this.voiceList));
      } catch (e) {
        console.error('خطا در ذخیره‌سازی', e);
      }
    },

    loadVoicesFromStorage() {
      // پیاده‌سازی بارگذاری
    },

    // 6. پاکسازی کامل
    cleanupResources() {
      clearInterval(this.timerInterval);
      if (this.stream) {
        this.stream.getTracks().forEach(track => track.stop());
      }
      if (this.mediaRecorder) {
        this.mediaRecorder = null;
      }
    }
  },
  computed: {
    combination1024() {
      const { show1024Flag, bottomList } = this;
      return {
        show1024Flag,
        bottomList,
      };
    },
  },
  watch: {
    combination1024: {
      handler: function (val) {
        if (!val.show1024Flag) {
          this.filteredBottomList = [...val.bottomList].filter(
            ({ status }) => status !== '10-24 موقت',
          );
        } else {
          this.filteredBottomList = [...val.bottomList];
        }
      },
      deep: true,
    },
    patiantPosition: function (currentVal) {
      if (!currentVal) return;

      this.getMapReverseGeoCode(currentVal);
      this.flyTo800PatientPosition();
      this.update800FencePhonesByLatLng(currentVal);
    },
    topListSoundStop: function (value) {
      if (value === false) this.setSoundInterval();
      else this.clearSoundInterval();
    },
    // selected800Position: function (value) {
    //   if (this.sendModalType !== "main") {
    //     this.showConfirmDialogFunction();
    //   }
    // },
  },
};
